<template>
  	<div class="stores">
    	<div class="breadcrumb">训练营 > 课程报名列表</div>
    	<div class="searchBtn">
	      	<div class="search_item">
	      		<div>课程名称</div>
	        	<input type="text" placeholder="请输入课程名称" class="el-input__inner" v-model="courseName" @keyup.enter="search_mine()"/>
	      	</div>

	      	<div class="search_item">
	      		<div>手机号</div>
	        	<input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="mobile" @keyup.enter="search_mine()"/>
	      	</div>
	      	<div class="search_item">
	      		<div>姓名</div>
	        	<input type="text" placeholder="请输入姓名" class="el-input__inner" v-model="userName" @keyup.enter="search_mine()"/>
	      	</div>
			<el-button type="primary" @click="search_mine()">搜索</el-button>
    	</div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
		          	<el-table-column prop="userName"  label="姓名"></el-table-column>
		          	<el-table-column prop="mobile" label="手机号"></el-table-column>
		          	<el-table-column prop="userCompany" label="公司"></el-table-column>
		          	<el-table-column prop="courseName" label="课程名称"></el-table-column>
		          	<el-table-column prop="createTime" :formatter="this.global.dateFormat" label="报名时间"></el-table-column>
		          	<el-table-column prop="courseStartTime" :formatter="this.global.dateFormat" label="课程开始时间"></el-table-column>	
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>
    	
  	</div>
</template>

<script>
export default {
  	components: {},
  	mounted() {
    	this.init();
  	},
  	data() {
    	return {
      		headers: {
        		xqiao_token: localStorage.getItem("token")
      		},
      		courseName:'',
      		mobile:'',
      		userName:'',
	      	tableData: [],
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
    	};
  	},
  	methods: {
    	//初始化表格数据
    	init() {
      		var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		courseName:this.courseName,
        		mobile:this.mobile,
        		userName:this.userName
      		};
      		this.$get("/trainingCamp/getList", params)
        	.then(res => {
          		if (res.code == 0) {
            		this.tableData = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
    	},
    	//当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    search_mine(){
	    	this.init();
	    },
  	}
};
</script>

<style scoped>
.searchBtn{
	display:flex
}
.search_item{
	display: flex;
	font-size:13px;
	align-items: center;
	margin-right: 20px
}
.search_item div{
	margin-right: 10px;
}
.search_item input{
	flex: 1
}

</style>



// WEBPACK FOOTER //
// src/views/trainingCamp/trainCampCouseApply.vue